module.exports = __webpack_public_path__ + "static/media/all_recommender.815d6465.png";